import i18n from 'i18next';
import {
	ICloseStopsConflictSingleVoyage,
	MIN_STORED_RADIUS_SINGLE_VOYAGE
} from "@containers/singleVoyage/containers/closeStops/findCloseStops";

/** Code track-api puts on the error, see CloseStopsCheck.CODE_STOPS_TOO_CLOSE. */
export const STOPS_TOO_CLOSE_CODE = 'STOPS_TOO_CLOSE'

export const buildCloseStopsPairMessage = (conflict: ICloseStopsConflictSingleVoyage): string => {
	const pair = i18n.t('singleVoyage.closeStops.pair', {
		first: `${conflict.firstNumber}. ${conflict.first.name}`,
		second: `${conflict.secondNumber}. ${conflict.second.name}`,
		distance: conflict.distance,
		radius: conflict.radius,
	})
	const fix = conflict.maxRadius >= MIN_STORED_RADIUS_SINGLE_VOYAGE
		? i18n.t('singleVoyage.closeStops.fixRadius', {radius: conflict.maxRadius})
		: i18n.t('singleVoyage.closeStops.fixMerge', {radius: MIN_STORED_RADIUS_SINGLE_VOYAGE})
	return `${pair} ${fix}`
}

export const buildCloseStopsMessage = (conflicts: ICloseStopsConflictSingleVoyage[]): string => {
	return conflicts.map(buildCloseStopsPairMessage).join(' ')
}

/**
 * Dispatcher wording for a STOPS_TOO_CLOSE error from the backend, or undefined for any other
 * error; the backend text is English and meant for a log. The voyage and template editors catch
 * the pairs before saving, so for them this is only a fallback. A moved stop template is checked
 * against templates the stop editor does not show, so there it is the only message.
 */
export const getCloseStopsErrorMessage = (
	error: unknown,
	source: 'stops' | 'stopTemplate' = 'stops',
): string | undefined => {
	const errors = (error as { errors?: { code?: string }[] })?.errors
	if (!Array.isArray(errors) || !errors.some((item) => item?.code === STOPS_TOO_CLOSE_CODE)) {
		return undefined
	}
	return i18n.t(source === 'stopTemplate' ? 'singleVoyage.closeStops.apiError' : 'singleVoyage.closeStops.apiErrorStops')
}
